export default "__VITE_ASSET__CKsXpCRp__"